module.exports = __webpack_public_path__ + "static/media/options.1ab1343a.svg";